import Marquee from "react-fast-marquee";

const words = ["Escucha", "Palabra", "Tiempo"];

export default function EditorialMarquee({ dark = false }) {
  return (
    <div
      className={`py-10 md:py-16 border-y ${
        dark ? "border-white/10" : "border-black/10"
      }`}
      data-testid="editorial-marquee"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display italic text-5xl md:text-7xl lg:text-8xl px-8 md:px-14 ${
                dark ? "text-white/25" : "text-[#1a1a1a]/15"
              }`}
            >
              {w}
            </span>
            <span
              className={`text-3xl md:text-5xl ${
                dark ? "text-[#9C5A4B]/70" : "text-[#9C5A4B]/60"
              }`}
            >
              —
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
